import { COLORS, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${paddingMd};

  ${respondTo.bigPhone`
    padding: 15rem;
  `}
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20rem;
`;

export const Title = styled.div`
  font-size: 24rem;
  font-weight: 300;
  line-height: 36rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${COLORS.BLACK};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20rem;
  margin-top: 10rem;

  ${respondTo.bigPhone`
    gap: 10rem;
  `}

  ${respondTo.smallPhone`
    gap: 5rem;
  `}
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  margin-bottom: 20rem;
  justify-content: center;

  input {
    text-align: center;
  }
`;
